module.exports = __webpack_public_path__ + "img/cost-icon__roof_garden.b8929e05.svg";